import { render, staticRenderFns } from "./ProductCardCharacteristics.vue?vue&type=template&id=1fc2193a&scoped=true&"
import script from "./ProductCardCharacteristics.vue?vue&type=script&lang=js&"
export * from "./ProductCardCharacteristics.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardCharacteristics.vue?vue&type=style&index=0&id=1fc2193a&lang=sass&scoped=true&"
import style1 from "./ProductCardCharacteristics.vue?vue&type=style&index=1&id=1fc2193a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc2193a",
  null
  
)

export default component.exports